import { AuditEntity } from "@app/common";
import { Attachment } from "@app/core";
import { Column, Display, prop, required, Table } from "@messaia/cdk";
import { TemplateType } from "../enums/template-type";

@Table({ endpoint: 'template', duplicable: true })
export class Template extends AuditEntity {
	@Display($localize`:@@type:Type`)
	@required()
	type: TemplateType = TemplateType.Email;

	@Column()
	@Display($localize`:@@name:Name`)
	@required()
	name: string;

	@Column({ maxWidth: 250, showGtLg: true })
	@Display($localize`:@@subject:Subject`)
	@prop()
	subject: string;

	@Column({ maxWidth: 150, showGtLg: true })
	@required()
	@Display('Key')
	key: string;

	@Display($localize`:@@notice:Notice`)
	@prop()
	notice: string;

	@Display($localize`:@@email:Email`)
	@prop()
	email: string;

	@required()
	content: string;

	@prop()
	dummyData: string;

	@Column({
		name: 'client.displayName',
		endpoint: 'client?enabled=true&projection=id,name',
		maxWidth: 250,
		showGtXl: true
	})
	@Display($localize`:@@client:Client`)
	@prop()
	clientId: number;

	@Column({ event: 'toggle' })
	@Display($localize`:@@enabled:Enabled`)
	@prop()
	enabled: true;

	@prop()
	attachments: Attachment[] = [];
}